import { FC } from 'react';
import { CurrentTarget, useStudentActiveFocus } from '../../custom-hooks/useStudentActiveFocus';

interface Props {
  /** Units in the student's current roadmap (currentTargetGroupByStudentId.targetGroup.targets). */
  currentTargets: ReadonlyArray<CurrentTarget>;
  /** Bump to force a network revalidation (e.g. on access-token change). */
  fetchKey?: string | number;
}

/**
 * Headless publisher (US-8, TEAMC-3148): reads the student's active teacher-assigned
 * focus and pushes it to focusSlice so focus-aware UI (the focus indicator and the
 * focused-unit highlight) works on routes other than the homepage. The slice is not
 * persisted and the homepage's StudentFocusController is the only other publisher, so
 * pages like All Units must publish it themselves. Renders nothing; the underlying
 * query suspends, so mount this inside a Suspense boundary.
 */
export const StudentFocusPublisher: FC<Props> = ({ currentTargets, fetchKey }) => {
  useStudentActiveFocus({ currentTargets, fetchKey });
  return null;
};

export default StudentFocusPublisher;
